import type { EquipmentSlots } from "../core/types";
import type { GameState } from "./GameState";
import { ITEMS } from "../data/items";
import { bus } from "../core/EventBus";

/** Equipamiento por ranuras corporales, separado del inventario (punto 14). */
export class EquipmentManager {
  constructor(private state: GameState) {}

  slots(): Readonly<EquipmentSlots> {
    return this.state.equipment;
  }

  /** Equipa un EPI en su ranura. No permite dos cascos: una ranura, un EPI. */
  equip(itemId: string): boolean {
    const def = ITEMS[itemId];
    if (!def || def.type !== "epi" || !def.slot) return false;
    this.state.equipment[def.slot] = itemId;
    this.state.persist();
    bus.emit("EQUIPMENT_CHANGED", { slot: def.slot, itemId });
    return true;
  }

  unequip(slot: keyof EquipmentSlots): void {
    if (this.state.equipment[slot] == null) return;
    this.state.equipment[slot] = null;
    this.state.persist();
    bus.emit("EQUIPMENT_CHANGED", { slot, itemId: null });
  }

  /** Consulta por id de EPI ("casco") o por ranura ("head"). */
  hasEquipment(idOrSlot: string): boolean {
    const eq = this.state.equipment;
    if (idOrSlot in eq) return eq[idOrSlot as keyof EquipmentSlots] != null;
    return Object.values(eq).includes(idOrSlot);
  }

  equippedIds(): string[] {
    return Object.values(this.state.equipment).filter((v): v is string => v != null);
  }

  clear(): void {
    (Object.keys(this.state.equipment) as (keyof EquipmentSlots)[]).forEach((s) => {
      this.state.equipment[s] = null;
    });
    this.state.persist();
  }
}
